import { useCallback, useEffect } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { useOptionsProvider } from '@frontend/call-intel-core';
import { useCallIntelFiltersContext } from '../../context/call-intel-filters.context';

const DEFAULT_CONTACT_TYPE: CallIntelTypes.ContactTypeFilterEnum[] = [];

export const useContactTypeFilterData = () => {
  const { filterValues, updateFilterValues, updateFilterModified, isLoading } = useCallIntelFiltersContext();
  const { getOptions } = useOptionsProvider();

  useEffect(() => {
    updateFilterModified({ contactTypes: !!filterValues.contactTypes?.length });
  }, [filterValues.contactTypes, updateFilterModified]);

  const onChange = useCallback(
    (value: CallIntelTypes.ContactTypeFilterEnum[]) => {
      updateFilterValues({ contactTypes: value });
    },
    [updateFilterValues]
  );

  return {
    contactTypeOptions: getOptions('contactType'),
    value: filterValues.contactTypes || [],
    defaultValue: DEFAULT_CONTACT_TYPE,
    isLoading,
    onChange,
  };
};
